export const refundCount: Record<"NO_REFUND" | "REFUND_ALL", number> = {
  NO_REFUND: 0,
  REFUND_ALL: -1,
};

export const refundType: Record<
  "NO_REFUND_TYPE" | "PARTIAL_REFUND_TYPE" | "REFUND_ALL_TYPE",
  number
> = {
  NO_REFUND_TYPE: 0,
  REFUND_ALL_TYPE: 1,
  PARTIAL_REFUND_TYPE: 2,
};
